import { useState, createContext, useContext } from 'react';

const ModeContext = createContext(null);

export const DarkModeProvider = ({ children }) => {
  const [mode, setMode] = useState('light');

  const toggleMode = () => {
    if (mode === 'light') {
      setMode('dark');
      document.body.style.backgroundColor = '#042743';
      document.body.style.color = 'black';
    } else {
      setMode('light');
      document.body.style.backgroundColor = 'white';
      document.body.style.color = 'black';
    }
  };

  return <ModeContext.Provider value={{ toggleMode }}>{children}</ModeContext.Provider>;
};

export const useDarkMode = () => useContext(ModeContext);
